export const MAX_CPU_WORKERS = 16;

export type CpuMiningSettings = {
  logicalProcessors: number;
  workerLimit: number;
  selectedWorkers: number;
  activeWorkers: number;
};

export function cpuCapacity(reported = typeof navigator === "undefined" ? 1 : navigator.hardwareConcurrency): CpuMiningSettings {
  const logicalProcessors = Number.isSafeInteger(reported) && reported >= 1 ? reported : 1;
  const workerLimit = Math.min(MAX_CPU_WORKERS, logicalProcessors);
  return { logicalProcessors, workerLimit, selectedWorkers: Math.max(1, Math.floor(workerLimit / 2)), activeWorkers: 0 };
}

export function validateCpuWorkers(value: number, limit: number): number {
  if (!Number.isInteger(value) || value < 1 || value > limit) throw new Error("INVALID_CPU_WORKER_COUNT");
  return value;
}
